export const imagesData = {
  'data-analytics':
    'https://crehana-vercel-images-prd.imgix.net/public/crehana-frontend-mf/automated-v2-55181d0d-8eb2-4913-9d4d-5d78d32c983e-data-analytics.jpg?auto=format',
  'marketing-digital':
    'https://crehana-vercel-images-prd.imgix.net/public/crehana-frontend-mf/automated-v2-fbf09a06-9fc4-40cf-b802-f5ad8fe9eefb-marketing-digital.jpg?auto=format',
  'product-management':
    'https://crehana-vercel-images-prd.imgix.net/public/crehana-frontend-mf/automated-v2-ed9b564e-878f-4f5f-b076-f72c331ae30f-product-management.jpg?auto=format',
  'ux-ui':
    'https://crehana-vercel-images-prd.imgix.net/public/crehana-frontend-mf/automated-v2-17e8beaf-e953-4e41-a6b3-22ae42272a21-ux-ui.jpg?auto=format',
};
